import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import classes from './PolicyPages.module.scss';
import Divider from '../../components/divider/Divider';

const PrivacyPolicy = () => {
  return (
    <Row className='g-0'>
      <Col lg={1}></Col>
      <Col lg={10}>
        <div className={`${classes.tsWrapper} mb-4`}>
          <Divider className='mt-0' />
          <h1 className='themeH1'>Flitz.ai Privacy Policy</h1>
          <p className={`${classes.para} my-3`}>Last updated: March 2026</p>
          <p className={`${classes.para} my-3`}>The authoritative version of this policy is published at <a href="https://flitz.ai/privacy">flitz.ai/privacy</a>.</p>

          <p className='dashSectionHead my-3'>1. Data Controller</p>
          <p className={`${classes.para} my-3`}>The entity managing data processing on this website is Flitz.ai, Switzerland. Personal data handling follows the Swiss Federal Act on Data Protection (FADP) and the EU General Data Protection Regulation (GDPR) where applicable.</p>

          <p className='dashSectionHead my-3'>2. Data We Collect</p>
          <ul className='my-3 ms-2'>
            <li className={`${classes.listItem} mb-2`}>Information provided during registration (name, email, company name).</li>
            <li className={`${classes.listItem} mb-2`}>Data generated through service usage (documents, entries and other content you create).</li>
            <li className={`${classes.listItem} mb-2`}>Technical information (IP address, browser type, access times).</li>
          </ul>

          <p className='dashSectionHead my-3'>3. How We Use Your Data</p>
          <p className={`${classes.para} my-3`}>Data enables provision and improvement of our services, processing of your content via AI, generation of reports and outputs, and account communications.</p>

          <p className='dashSectionHead my-3'>4. AI Processing</p>
          <p className={`${classes.para} my-3`}>Documents and content are processed by third-party AI providers for data extraction and generation. Content reaches AI APIs for processing but is not used for model training. The current list of AI subprocessors is published in our subprocessor register and updated when providers change.</p>

          <p className='dashSectionHead my-3'>5. Data Storage &amp; Security</p>
          <p className={`${classes.para} my-3`}>All data resides on EU servers. We employ AES-256 encryption for stored data and TLS 1.3 for data in transit. Customer data remains isolated at the database level through a multi-tenant architecture.</p>

          <p className='dashSectionHead my-3'>6. Data Sharing</p>
          <p className={`${classes.para} my-3`}>We do not sell your data. Data sharing occurs with third-party AI providers, payment processors (Stripe), and as legally required by Switzerland.</p>

          <p className='dashSectionHead my-3'>7. Your Rights</p>
          <p className={`${classes.para} my-3`}>You may access, correct, or delete your personal data and export your information at any time by contacting us via <a href="https://flitz.ai/privacy">flitz.ai/privacy</a>.</p>

          <p className='dashSectionHead my-3'>8. Cookies &amp; Analytics</p>
          <ul className='my-3 ms-2'>
            <li className={`${classes.listItem} mb-2`}><b>Essential cookies:</b> Required for session management, authentication, CSRF protection, and tenant context retention; cannot be disabled.</li>
            <li className={`${classes.listItem} mb-2`}><b>Analytics cookies:</b> Google Analytics 4 tracks visitor traffic and engagement on public marketing pages only. You may opt out via browser settings, the Google Analytics opt-out add-on, or by contacting us.</li>
          </ul>
        </div>
      </Col>
      <Col lg={1}></Col>
    </Row>
  )
}

export default PrivacyPolicy
